import { EvaluationStatus } from '../types';

// Display labels + one-line descriptions for the "Notify my agent" status
// picker, in the style of USER_ROLE_META (src/types/index.ts). The status
// ids are the single source of truth on the client; functions/src/agents/
// notifyAgent.ts keeps a local copy of the three ids (functions/ can't
// import from src/ — see its comment) and must be kept in step by hand.
export const EVALUATION_STATUS_META: Record<EvaluationStatus, { label: string; blurb: string }> = {
  started: {
    label: 'Just getting started',
    blurb: 'You are early in preparing this property.',
  },
  'needs-input': {
    label: 'Need your input',
    blurb: 'You have a question or need something from your agent.',
  },
  complete: {
    label: 'Complete',
    blurb: 'The checklist is done and ready for review.',
  },
};

export const EVALUATION_STATUSES: EvaluationStatus[] = ['started', 'needs-input', 'complete'];
